// LanguagePicker.tsx
import * as React from 'react';
import { Menu, MenuItem, IconButton, Tooltip, Zoom } from '@mui/material';
import SerbiaIcon from '../components/icons/SerbianFlag';
import EnglishIcon from '../components/icons/EnglishFlag';
import { LanguageSelectProps } from '../types/navigationProperties';
import { WHProps } from '../types/widthHeightProperties';
import { useTranslation } from 'react-i18next';

export default function LanguagePicker(props: LanguageSelectProps) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [language, changeLanguage] = [props.language, props.changeLanguage];
    let selectedLanguage: string = language;
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLanguageSelection = (lang: 'en' | 'sr') => () => {
        changeLanguage(lang);
        selectedLanguage = lang;
        handleClose();
    };
    const selectBtnSize: WHProps = {height: 40, width: 50};
    const listBtnSize: WHProps = {height: 20, width: 35};
    const icon = {
        en: <EnglishIcon {...selectBtnSize} />,
        sr: <SerbiaIcon {...selectBtnSize} />,
    }[selectedLanguage];

    return (
        <React.Fragment>
            <Tooltip title={t("language.picker")}
                     placement="bottom"
                     slots={{
                        transition: Zoom,
                     }}
                     slotProps={{
                        transition: { timeout: 300 },
                     }} arrow>
                <IconButton
                    data-screenshot="toggle-mode"
                    onClick={handleClick}
                    disableRipple
                    sx={{
                        width: 50,
                        height: 40
                    }}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}>
                    {icon}
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        variant: 'outlined',
                        elevation: 0,
                        sx: {
                            my: '4px',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <Tooltip title={t("language.english")}
                         placement="bottom"
                         slots={{
                            transition: Zoom,
                         }}
                         slotProps={{
                            transition: { timeout: 300 },
                         }} arrow>
                    <MenuItem selected={selectedLanguage === 'en'} onClick={handleLanguageSelection('en')}>
                        <EnglishIcon {...listBtnSize} /> {t("language.english")}
                    </MenuItem>
                </Tooltip>
                <Tooltip title={t("language.serbian")}
                         placement="bottom"
                         slots={{
                            transition: Zoom,
                         }}
                         slotProps={{
                            transition: { timeout: 300 },
                         }} arrow>
                    <MenuItem selected={selectedLanguage === 'sr'} onClick={handleLanguageSelection('sr')}>
                        <SerbiaIcon {...listBtnSize} /> {t("language.serbian")}
                    </MenuItem>
                </Tooltip>
            </Menu>
        </React.Fragment>
    );
}